/**
 * RG WhatsApp Floating Button
 * Handles redirection and event tracking
 */

document.addEventListener('DOMContentLoaded', () => {
    const waFloater = document.querySelector('[data-rg-whatsapp]');

    if (waFloater) {
        const btn = waFloater.querySelector('.rg-whatsapp-btn');
        const phoneNumber = waFloater.dataset.phone;
        const message = waFloater.dataset.message;

        // Sanitize phone (remove non-digits if user added + or spaces)
        const cleanPhone = phoneNumber.replace(/\D/g, '');

        btn.addEventListener('click', (e) => {
            e.preventDefault();

            // 1. Dispatch Tracking Event
            // neosocios.js or other trackers will listen to this
            const eventDetail = {
                action: 'click',
                label: 'WhatsApp Floating Button',
                destination: `https://wa.me/${cleanPhone}`,
                page_url: window.location.href
            };

            // Custom Event dispatch
            document.dispatchEvent(new CustomEvent('whatsapp:clicked', {
                detail: eventDetail
            }));

            // 2. Open WhatsApp (Short delay to ensure event dispatch fires)
            // Using a tiny timeout just to be safe with event loop
            setTimeout(() => {
                const url = `https://wa.me/${cleanPhone}?text=${encodeURIComponent(message)}`;
                window.open(url, '_blank');
            }, 100);
        });
    }
});
